export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_USER_ROOMS = "GET_USER_ROOMS";
export const GET_USER_INFO = "GET_USER_INFO";
export const EDIT_USER = "EDIT_USER";
export const GET_USER_PREDICTIONS = "GET_USER_PREDICTIONS";
export const EDIT_USER_PREDICTION = "EDIT_USER_PREDICTION";